import { Route } from "react-router-dom";
import styles from "./styles.module.css";
import PasswordReset from "./passwordReset";
import Signup from "./betasignup";
import Verify from "./verify";
import Reset from "./reset";
import Login from "./login";
import logo from "../../Logo.png";

export default function Auth() {
  return (
    <div className={styles.auth}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: 15,
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <img src={logo} alt="BREVITY LOGO" width={40} height={40} />
        <div className={styles.topText}>BREVITY</div>
      </div>
      <Route path="/auth/login">
        <Login />
      </Route>
      <Route path="/auth/signup">
        <Signup />
      </Route>
      <Route path="/auth/verify">
        <Verify />
      </Route>
      <Route path="/auth/reset">
        <Reset />
      </Route>
      <Route path="/auth/password-reset">
        <PasswordReset />
      </Route>
    </div>
  );
}
